"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkEmail = exports.countryList = exports.adminUserList = exports.businessList = exports.register = exports.getPutOssAuthUrl = exports.getSecurityToken = void 0;
const vue_1 = __importDefault(require("vue"));
const http = () => {
    return vue_1.default.prototype.$http;
};
// 获取oss授权token
exports.getSecurityToken = (params) => __awaiter(void 0, void 0, void 0, function* () { return http().get(`/aliOss/getSecurityToken?type=${params}`); });
// 获取oss上传凭证
exports.getPutOssAuthUrl = (params) => __awaiter(void 0, void 0, void 0, function* () { return http().post('/aliOss/getPutOssAuthUrl', params); });
// 注册
exports.register = (params) => __awaiter(void 0, void 0, void 0, function* () { return http().post('/customerContacts/register', params); });
// 根据坐标获取服务商
exports.businessList = (params) => __awaiter(void 0, void 0, void 0, function* () { return http().post('/customer/list', params); });
// 业务员列表
exports.adminUserList = (params) => __awaiter(void 0, void 0, void 0, function* () { return http().post('/adminUser/list', params); });
// 贸易国别
exports.countryList = (params) => __awaiter(void 0, void 0, void 0, function* () { return http().post('/country/list', params); });
exports.checkEmail = (params) => __awaiter(void 0, void 0, void 0, function* () { return http().post('/customerContacts/checkEmail', params); });
